import * as React from "react";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { HyperLink } from "~/sharedComponents/hyperlink/HyperLink";
import * as styles from "./toastr.less";

interface FeedbackResultProps<T = any> {
    list: T[];
    title?: string;
    getName?: (result: T) => string;
    formatter?: (result: T) => string;
    getItem?: (result: T) => React.ReactNode;
}

interface Props<T = any> {
    description: string;
    result?: FeedbackResultProps<T>;
    link?: {
        url: string;
        anchor: string;
        onClink?: (e?: any) => void;
    };
    forceShowAll?: boolean;
}

export const builderFeedback = <T,>(): React.FC<Props<T>> => {
    return ({ description, result, link, children, forceShowAll = false }) => {
        const [showMore, setShowMore] = React.useState(forceShowAll);

        return (
            <>
                <div>{description}</div>
                {result && (
                    <>
                        <div>{result.title}</div>
                        {showMore && (
                            <ul className={styles.list}>
                                {result.list.map((x, i) => (
                                    <li key={`${i}_${result.getName(x)}`}>
                                        {result.getItem
                                            ? result.getItem(x)
                                            : `${result.getName(x)} - ${result.formatter(x)}`}
                                    </li>
                                ))}
                            </ul>
                        )}
                        <div className={styles.show_more} onClick={() => setShowMore(!showMore)}>
                            {showMore ? commonClientResx.show_less_label : commonClientResx.show_more_label}
                        </div>
                    </>
                )}
                {link && (
                    <HyperLink href={link.url} colored={true}>
                        {link.anchor}
                    </HyperLink>
                )}
                {children && <div>{children}</div>}
            </>
        );
    };
};

export const Feedback = builderFeedback();
